import { CourseCardData } from '../../../components/CourseCard/CourseCard.types';
import { Course, Chapter, ChaptersResponse } from './types';

/**
 * Форматирует время курса в часы и минуты
 */
const formatCourseTime = (timeInMinutes: number | null): string | undefined => {
    if (timeInMinutes === null) {
        return undefined;
    }

    const hours = Math.floor(timeInMinutes / 60);
    const minutes = timeInMinutes % 60;

    if (hours === 0) {
        return `${minutes} мин`;
    }

    if (minutes === 0) {
        return `${hours} ч`;
    }

    return `${hours} ч ${minutes} мин`;
};

/**
 * Преобразует Course из API в CourseCardData для компонента
 */
export const transformCourseToCard = (course: Course): CourseCardData => {
    const timeToComplete = formatCourseTime(course.course_time);
    const numberOfChapters = course.chapters_count ?? undefined;
    const externalLink = course.external_link || undefined;

    return {
        id: course.id.toString(),
        title: course.name,
        tagline: course.tagline,
        image: course.cover_image_url || '',
        ...(timeToComplete && { timeToComplete }),
        ...(numberOfChapters !== undefined && { numberOfChapters }),
        ...(externalLink && { externalLink }),
    };
};

/**
 * Преобразует массив Course из API в массив CourseCardData для компонентов
 */
export const transformCoursesToCards = (courses: Course[]): CourseCardData[] => courses.map(transformCourseToCard);

/**
 * Преобразует ответ API с курсами в массив карточек курсов
 */
export const transformCoursesResponseToCards = (response: { courses: Course[] }): CourseCardData[] =>
    transformCoursesToCards(response.courses);

/**
 * Преобразует Chapter из API, обрезая кавычки из chapter_time
 */
export const transformChapter = (chapter: Chapter): Chapter => ({
    ...chapter,
    chapter_time: chapter.chapter_time.replace(/^["']|["']$/g, ''),
});

/**
 * Преобразует ответ API с главами, обрезая кавычки из времени глав
 */
export const transformChaptersResponse = (response: ChaptersResponse): ChaptersResponse => ({
    ...response,
    chapters: response.chapters.map(transformChapter),
});

/**
 * Преобразует ответ API с одной главой, обрезая кавычки из chapter_time
 */
export const transformChapterResponse = (chapter: Chapter): Chapter => transformChapter(chapter);
